import EventNames from '../constants/EventNames';

class AbstractGoogleAnalytics {
  constructor() {
    this.allowedEvents = [
      EventNames.ADD_PAYMENT_INFO,
      EventNames.ANNOTATE_PHOTO,
      EventNames.COMMENT,
      EventNames.COMPLETE_REGISTRATION,
      EventNames.CREATE_BEFORE_AFTER,
      EventNames.CREATE_PROJECT,
      EventNames.CREATE_REPORT,
      EventNames.INVITE_USER,
      EventNames.SCAN_DOCUMENT,
      EventNames.SHARE_GALLERY,
      EventNames.SHARE_REFERRAL_LINK,
      EventNames.SHARE_TIMELINE,
      EventNames.TAKE_PHOTO,
      EventNames.TAKE_VIDEO,
      EventNames.VIEW_SCREEN,
    ];
  }

  shouldLogEvent = (name) => {
    return this.allowedEvents.includes(name);
  };
}

export default AbstractGoogleAnalytics;
